function sanitizeLightmapId(value: string): string {
  return value.replace(/[^a-zA-Z0-9_-]/g, '_');
}

export function createLightmapTargetId(componentUuid: string, meshIndex?: number): string {
  const base = sanitizeLightmapId(componentUuid);
  return meshIndex === undefined ? base : `${base}:${meshIndex}`;
}

export function createLightmapLightId(actorUuid: string, componentUuid: string): string {
  return `${sanitizeLightmapId(actorUuid)}_${sanitizeLightmapId(componentUuid)}`;
}
